export enum GameState {
    Lobby,
    InGame,
    PostGame
}